import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { EnumDescriptor } from '../../enum-descriptor';
import { IntegrationState } from 'src/app/proxy/integrations-status';

@Component({
  selector: 'app-integration-state-dropdown',
  standalone: false,
  templateUrl: './integration-state-dropdown.component.html',
})
export class IntegrationStateDropdownComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() integrationStateSelected: EnumDescriptor;
  @Input() isDisabled = false;

  @Output() changeSelectedIntegrationState = new EventEmitter<EnumDescriptor>();

  integrationStates: EnumDescriptor[];
  selectedIntegrationState: EnumDescriptor;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadIntegrationStates();
    this.onSelected();
  }

  loadIntegrationStates(): void {
    this.integrationStates = this.getEnumOptions(IntegrationState, false);
  }

  setSelectedState(value: EnumDescriptor | undefined): void {
    this.selectedIntegrationState = value;
    this.onSelected();
  }

  onSelected(): void {
    this.changeSelectedIntegrationState.emit(this.selectedIntegrationState);
  }
}
